
export const PATHS = {
  ROOT: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  INFO: "/info",
  ORGANISATIONS: "/organisations",
  OVERVIEW: "/overview",
  TAGS: "/tags",
  CLASSES: "/classes",
  CLASS: "/classes/:id",
  CLASS_RECORDS: "/classes/:id/records",
  ALL_RECORDS: "/classes/records",
  CLASS_CREATE: "/classes/create",
  PEOPLE: "/people",
  BIRTHDAYS: "/birthdays",
  PERSON: "/people/:id",
  PERSON_RECORDS: "/people/:id/records",
  PEOPLE_CREATE: "/people/create",
  ONBOARDING: "/onboarding",
  ADMIN_TOOLS: "/admin",
  DASHBOARD: "/dashboard",
  ATTENDANCE: "/attendance",
  LOGOUT: "/logout",

  POSTS: "/posts",
  POSTS_CREATE: "/posts/compose",
  POST_REVIEWS: "/posts/reviews",
  POST_REVIEW: "/posts/reviews/:postId",
  GALLERY: "/gallery",
  TAG_IMAGE: "/gallery/:imageId/tags",

  // old - just here for redirection
  COURSES: "/courses",
  COURSE: "/courses/:id",
}
